import "react-native-get-random-values";
import React from "react";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { View, StyleSheet, Platform } from "react-native";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { LikedNamesProvider } from "./context/LikedNamesContext";
import { AppProvider } from "./context/AppContext"; // Import AppProvider
import AppNavigator from "./components/AppNavigator";

// Import global CSS for web platform
if (Platform.OS === 'web') {
  require('./global.css');
}
import {
  useFonts,
  Urbanist_400Regular,
  Urbanist_700Bold,
  Urbanist_900Black,
} from "@expo-google-fonts/urbanist";
import AppLoading from "expo-app-loading";

const App = () => {
  const [fontsLoaded] = useFonts({
    Urbanist_400Regular,
    Urbanist_700Bold,
    Urbanist_900Black,
  });

  if (!fontsLoaded) {
    return <AppLoading />;
  }

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <SafeAreaProvider>
        <AppProvider>
          <LikedNamesProvider>
            <View style={styles.centeredContainer}>
              <AppNavigator />
            </View>
          </LikedNamesProvider>
        </AppProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  );
};

const styles = StyleSheet.create({
  centeredContainer: {
    flex: 1,
    maxWidth: 800, // Mimic mobile screen width
    alignSelf: "center", // Center horizontally
    width: "100%", // Allow it to shrink on smaller screens
    backgroundColor: "#F9FAFB", // Match the app's background color
  },
});

export default App;
